import {Button, Grid, Typography} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import {useEffect} from "react";
import useFetch from "../../../hooks/useFetch";
import CONFIG from "../../../config/_config";
import CategoriesListTable from "./CategoriesListTable";
import {useModal} from "../../../store/admin/ModalProvider";



const CategoriesList = () => {
    const {makeRequest, response} = useFetch();
    const {openModal} = useModal();

    const getCategoriesFromServer = () => {
        makeRequest(CONFIG.adminApiUrl + 'category_ajax.php', 'post', {getAllCategories: 1})
    }

    useEffect(() => {
        getCategoriesFromServer();

        window.addEventListener('categoriesChanged', () => getCategoriesFromServer())
    }, []);

    let categoriesList = [];

    if (response && response.state === 'success'){
        categoriesList = response.data.map(c => {
            return {
                id: c.id,
                name: c.name,
                description: c.description,
                productsCount: c.products_count
            }
        })
    }

    const onAddNewCategory = () => {
        openModal('CategoryFormModal');
    }

    return <>
        <Grid container>
            <Grid item xs={12} sx={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
                <Button
                    sx={{my: 0.5, ml: 2, py: 1, px: 3}}
                    variant="contained"
                    startIcon={<AddIcon />}
                    onClick={onAddNewCategory} >
                    Nuova
                </Button>
            </Grid>
        </Grid>
        <CategoriesListTable data={categoriesList} loading={(!response || response.state !== 'success')} />
    </>
}

export default CategoriesList;